import React, { useState } from 'react';

import NotFoundPage from '../components/reusable/error-pages/NotFoundPage/NotFoundPage';

interface ILayoutContextValue {
  showNotFoundPage: () => void;
  hideNotFoundPage: () => void;
  showMenu: () => void;
  hideMenu: () => void;
  isMenuOpen: boolean;
}

const LayoutContext = React.createContext<ILayoutContextValue | undefined>(
  undefined,
);

interface ILayoutProviderProps {
  children: React.ReactNode;
}

export function LayoutProvider(props: ILayoutProviderProps) {
  const [isNotFoundPage, setIsNotFoundPage] = useState<boolean>(false);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  function showNotFoundPage() {
    if (!isNotFoundPage) setIsNotFoundPage(true);
  }

  function hideNotFoundPage() {
    if (isNotFoundPage) setIsNotFoundPage(false);
  }

  function showMenu() {
    setIsMenuOpen(true);
  }

  function hideMenu() {
    setIsMenuOpen(false);
  }

  return (
    <LayoutContext.Provider
      value={{
        showNotFoundPage,
        hideNotFoundPage,
        showMenu,
        hideMenu,
        isMenuOpen,
      }}>
      {!!isNotFoundPage && <NotFoundPage />}
      {props.children}
    </LayoutContext.Provider>
  );
}

function useLayout() {
  const context = React.useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within an LayoutContext');
  }

  return context;
}

export { useLayout, LayoutContext };
